import React from 'react';
import { Link } from "react-router-dom";
import { Row, Col } from 'react-bootstrap';
class Home extends React.Component {
    componentDidMount(){
        document.title = "Tunis - React Personal Portfolio";
    }
    render() {
        return(
            <div className="home h-100">
                <div className=" container-fluid main-container container-home p-0">
                    <div className="color-block d-none d-lg-block"></div>
                    <Row className="home-details-container align-items-center">
                        <Col lg={4} className="bg position-fixed d-none d-lg-block"></Col>
                        <Col lg={{ span: 8, offset: 4 }} className="col-12 col-lg-8 offset-lg-4 home-details text-left text-sm-center text-lg-left">
                            <div>
                                <h6 className="text-uppercase open-sans-font mb-0 d-block d-sm-none d-lg-block">hi there
                                    !</h6>
                                <h1 className="text-uppercase poppins-font"><span>I'm</span> steve milner</h1>
                                <p className="open-sans-font">I'm a Tunisian based web designer & front‑end developer
                                    focused on crafting clean & user‑friendly experiences, I am passionate about building
                                    excellent software that improves the lives of those around me.</p>
                                <Link to={'/about'} className="btn btn-about">
                                    <span>more about me</span>
                                </Link>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}

export default Home
